<template>
  <div>
    <div>
      <b-row class="mt-3 mb-3 center">
        <b-col lg="4">
          <b-form-checkbox v-model="selectAllRows" @change="toggleAll">
            Clique aqui para
            <b v-if="selectAllRows">desmarcar</b>
            <b v-else>marcar</b>
            todos
          </b-form-checkbox>
        </b-col>
      </b-row>
    </div>
    <div v-for="item in items" :key="item.nome">
      <ul class="my-1">
        <label :for="item.nome" class="mx-0">
          <div class="row">
            <button
              v-if="item.subitems"
              class="botao-pasta"
              @click="toggle(item)"
            >
              <b-icon
                align-v="center"
                :icon="
                  item.mostrarFilhos
                    ? 'caret-down-square-fill'
                    : 'caret-right-square-fill'
                "
                scale="1"
                aria-hidden="true"
              />
            </button>
            <button v-else class="vazio"></button>

            <input
              class="mx-2"
              type="checkbox"
              v-model="item.selecionado"
              :value="item.valor"
              :name="item.nome"
              @change="selecionarTodosNivel"
            />
            {{ item.nome }}
            <span
              class="ml-1"
              v-b-tooltip.hover.rightbottom="{ variant: 'primary' }"
              :title="item.tooltip"
            >
              <b-icon variant="primary" icon="info-circle-fill" />
            </span>
          </div>
        </label>

        <div v-if="item.mostrarFilhos">
          <li
            v-for="subitem in item.subitems"
            class="ml-5 my-0"
            :key="subitem.nome"
          >
            <label :for="subitem.nome">
              <input
                id="tooltip-target-1"
                type="checkbox"
                v-model="subitem.selecionado"
                :name="subitem.nome"
                :value="subitem.valor"
                @change="selecionar"
              />
              {{ subitem.nome }}
              <span
                v-b-tooltip.hover.rightbottom="{ variant: 'primary' }"
                :title="subitem.aTooltip"
              >
                <b-icon variant="primary" icon="info-circle-fill" />
              </span>
            </label>
          </li>
        </div>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      selecionados: [],
      cobranca: [],
      listaAll: [],
      selectAllRows: false,
    };
  },
  mounted() {
    this.montaAllLista();
    this.selectAllRows = false;
    const marcaAutomatico = this.items.length == 1;
    this.items.forEach((item) => {
      this.$set(item, "selecionado", marcaAutomatico);     
      this.$set(item, "mostrarFilhos", false);
      item.subitems.forEach((subitem) => {
        this.selecionados = this.selecionados.filter(
          (value) => value !== subitem.valor
        );
        this.$set(subitem, "selecionado", marcaAutomatico);
        if (this.items.length == 1) this.selecionarManual(subitem.valor, true);
      });
    }); 
  },
  watch: {
    selecionados: {
      handler() {    
        this.items.map((item) => {
          if (item.subitems) {
            let vazio = item.subitems.every(
              (subitem) => subitem.selecionado === false
            );
            if (vazio) this.$set(item, "selecionado", false);
            else {
              let preenchidos = item.subitems.every(
                (subitem) => subitem.selecionado === true
              );
              if (preenchidos) this.$set(item, "selecionado", true);
            }
          }
        });      
      },
    },   
  },
  methods: {
        montaGridCheckbox(marcado, nome, valor, subitems) {
          for (let i = 0; i < this.items.length; i++) {
            if (this.items[i].subitems.length) {
              for (let h = 0; h < this.items[i].subitems.length; h++) {
                if (this.items[i].nome === nome) {
                  if (marcado) {
                    this.cobranca.push(this.items[i].subitems[h]);
                  } else {
                    this.cobranca.splice(
                      this.cobranca.indexOf(this.items[i].subitems[h]),
                      1
                    );
                  }
                }
              }
            }
          }
          if (marcado && subitems) {
            subitems.forEach((subitem) => {
              const existe = this.selecionados.find((item) => item === valor);
              if (!existe) {
                this.selecionados.push(subitem.valor);
                this.$set(subitem, "selecionado", true);
              }
            });
          } else if (marcado && !subitems) {
            this.selecionados.push(valor);
          } else if (!marcado && !subitems) {
            this.selecionados = this.selecionados.filter((item) => item !== valor);
          } else {
            /// desmarcado
            subitems.forEach((subitem) => {
              this.selecionados = this.selecionados.filter(
                (value) => value !== subitem.valor
              );
              this.$set(subitem, "selecionado", false);
            });
          }
          this.$emit("mostrarDebitosSelecionados", this.cobranca);
        },

        montaAllLista() {
          const marcado = true;  
          for (let x = 0; x < this.items.length; x++) {
            const nome = this.items[x].nome;
          for (let i = 0; i < this.items.length; i++) {
            if (this.items[i].subitems.length) {
              for (let h = 0; h < this.items[i].subitems.length; h++) {
                if (this.items[i].nome === nome) {
                  if (marcado) {
                    this.listaAll.push(this.items[i].subitems[h]);
                  } else {
                    this.listaAll.splice(
                      this.listaAll.indexOf(this.items[i].subitems[h]),
                      1
                    );
                  }
                }
              }
            }
          }
          }  
        },

        toggleAll(checked) {
          this.selectAllRows = checked;
          const marcado = checked;
          for (let x = 0; x < this.items.length; x++) {
            const nome = this.items[x].nome;
            const valor = this.items[x].subitems;
            const subitems = this.items.find((item) => item.nome === nome)?.subitems; 
            this.montaGridCheckbox(marcado, nome, valor, subitems);
          }      
        },

        toggle(mostrarFilhos) {
          this.$set(mostrarFilhos, "mostrarFilhos", !mostrarFilhos.mostrarFilhos);
        },
        selecionarTodosNivel(event) {
          const marcado = event.target.checked;
          const nome = event.target.name;
          const valor = event.target.value;
          const subitems = this.items.find((item) => item.nome === nome)?.subitems;

          this.montaGridCheckbox(marcado, nome, valor, subitems);

          if (this.cobranca.length === this.listaAll.length) {
              this.selectAllRows = true;
          } else if (this.cobranca.length === 0) {
                    this.selectAllRows = false;
          } 
        },

        selecionar(event) {
          const obj = event.target.value;
          const marcado = event.target.checked;
          const existe = this.selecionados.find((item) => item.valor === obj.valor);
          this.montaGrid(obj, existe, marcado);    
        },

        selecionarManual(valor, marcado) {
          const obj = valor;
          const existe = this.selecionados.find((item) => item === obj);
          this.montaGrid(obj, existe, marcado);
        },   
    
        montaGrid(obj, existe, marcado) {
          for (let i = 0; i < this.items.length; i++) {
            if (this.items[i].subitems.length) {
              for (let h = 0; h < this.items[i].subitems.length; h++) {
                if (this.items[i].subitems[h].valor === obj) {
                  if (marcado) {
                    this.cobranca.push(this.items[i].subitems[h]);
                  } else {
                    this.cobranca.splice(
                      this.cobranca.indexOf(this.items[i].subitems[h]),
                      1
                    );
                  }
                }
              }
            }
          }
          this.$emit("mostrarDebitosSelecionados", this.cobranca);
          // }
          if (marcado && !existe) {
            this.selecionados.push(obj);
          } else {
            this.selecionados = this.selecionados.filter(
              (item) => item.valor !== obj.valor
            );
          }
          if (this.cobranca.length === this.listaAll.length) {
              this.selectAllRows = true;
          } else if (this.cobranca.length === 0) {
                    this.selectAllRows = false;
          } 
        },
      },
    };
</script>

<style scoped>
ul,
li {
  list-style: none;
}

.botao-pasta {
  background: none;
  border: none;
  outline: none;
  font-size: 0.75rem;
}

.vazio {
  background: none;
  border: none;
  outline: none;
  content: " ";
  margin-right: 12px;
}

.tooltip .tooltip-inner {
  max-width: 1650px !important;
  /* If max-width does not work, try using width instead */
  width: 1850px !important;
}
</style>